export default {
  properties: [],
};
